/** @format */

import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from "chart.js";
import { Line } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
  ChartDataLabels
);

const LineChartComponent = ({ monthlyData, month }) => {
  const excludeKeys = ["birligi", "id", "nomi"];

  const labels = Object.keys(monthlyData).filter(
    (key) => !excludeKeys.includes(key)
  );

  const year2024Data = labels.map((kun) => Number(monthlyData[kun][1]));
  const year2025Data = labels.map((kun) => Number(monthlyData[kun][0]));

  const allData = [...year2024Data, ...year2025Data];
  const maxValue = Math.max(...allData);

  const newMaxValue = maxValue % 10 === 0 ? maxValue + 10 : maxValue + 100;

  const data = {
    labels: labels.map((_, index) => (index + 1).toString()),
    datasets: [
      {
        label: new Date(month).getFullYear() - 1,
        data: year2024Data,
        borderColor: "#FF6384",
      },
      {
        label: new Date(month).getFullYear(),
        data: year2025Data,
        borderColor: "#36A2EB",
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: { position: "top" },
      title: {
        display: true,
        text: "Oylik kesimda yillik chiziqli taqqoslash",
      },
      tooltip: {
        callbacks: {
          title: function (tooltipItems) {
            const index = tooltipItems[0].dataIndex;
            return `${index + 1}-kun`;
          },
          label: function (context) {
            const label = context.dataset.label || "";
            const value = context.parsed.y || 0;
            return `${label}: ${value} ${monthlyData.birligi}`;
          },
        },
      },
      datalabels: null,
    },
    scales: {
      y: {
        beginAtZero: true,
        suggestedMax: newMaxValue,
        ticks: {
          callback: function (value) {
            return `${value} ${monthlyData.birligi}`;
          },
        },
      },
    },
  };

  return (
    <div style={{ width: "100%", minWidth: "1200px", height: "550px" }}>
      <Line data={data} options={options} />
    </div>
  );
};

export default LineChartComponent;
